/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class ShellImageKey {
  static readonly VENDOR_LOGO = 'assets/image/signum-software-logo.svg';
}
